<template>
  <div id="page-user-edit" v-if="operation_data">
    <div slot="no-body" class="tabs-container px-6 pt-6">
      <div class="tab-text">
        <template>
          <div id="user-edit-tab-info">
            <!-- Content Row -->
            <div class="vx-row">
              <div class="vx-col lg:w-1/3 w-full">
                <vx-card title="Document" class="mb-base">
                  <div ref="container" class="zoom-container" @wheel="onWheel" @mousedown="startDrag" @mousemove="onDrag"
                    @mouseup="endDrag" @mouseleave="endDrag">
                    <img :src="`https://xylo.codesinn.com/ftp/${operation_data.name}`" width="100%" :style="imageStyles">
                    <div class="controls">
                    </div>
                  </div>
                </vx-card>
              </div>
              <div class="vx-col md:w-2/3 w-full">
                <div class="vx-col md:w-2/2 w-full">
                  <vx-card>
                    <vs-tabs alignment="fixed">
                      <vs-tab label="Main" icon-pack="feather" icon="icon-home">

                        <div class="w-full mt-2">
                          <div style="font-size: 80%;">Supplier</div>
                          <div class="vx-row">
                            <div class="vx-col w-2/3">
                              <v-select autocomplete :options="data_option_people_name" v-model="personId" />
                            </div>
                            <div class="vx-col w-1/3">
                              <vs-button class="ml-auto" color="#333b34"
                                @click="record_data_go_to_add_person()">Add</vs-button>
                            </div>
                          </div>
                        </div>
                        <p class="w-full mt-2">
                        <div style="font-size: 80%;">Date</div>
                        <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                        </p>
                        <p class="w-full mt-2">
                        <div style="font-size: 80%;">Due Date</div>
                        <datepicker :inline="false" v-model="operation_data.date_delivery_desired"></datepicker>
                        </p>
                        <div class="vx-col w-full mt-4">
                          <div style="font-size: 80%;">Encoding Status</div>
                          <vs-switch color="success" v-model="operation_data.isexpvalid">
                            <span slot="on">Valid</span>
                            <span slot="off">Not Valid</span>
                          </vs-switch>
                        </div>
                        <div class="vx-col w-full mt-2">
                          <div style="font-size: 80%;">Payment Status</div>
                          <vs-switch color="success" v-model="operation_data.isexppaid">
                            <span slot="on">Is paid</span>
                            <span slot="off">Not Paid</span>
                          </vs-switch>
                        </div>
                        <vs-alert color="success" title="Total" active="true" class="mt-4" style="height:130px;">Total Excl. Tax : {{
                          thesum }} 
                          <vs-button type="border" size="small" color="danger" @click="updateVat(true)">The total Include VAT</vs-button>
                          <br />Tax : {{ thetax }}<br/>Total
                          Incl. Tax : {{ thesumtt }}&nbsp;
                          <!--<vs-button type="border" size="small" color="danger" class="mt-2" @click="updateVat(false)">Correct Missing VAT</vs-button>--></vs-alert>

                        <vs-button class="ml-auto mt-16 w-full" color="success" @click="save_changes"
                          :disabled="!validateForm">Save Changes</vs-button>
                        <vs-button class="ml-auto mt-4 w-1/4" v-if="operation_data.isactive" type="border" color="danger"
                          icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Delete</vs-button>
                        <vs-button v-else class="ml-auto mt-4 w-1/4" type="border" color="success" icon-pack="feather"
                          icon="icon-trash" @click="confirmEnableRecord">Enable</vs-button>
                      </vs-tab>
                      <vs-tab label="Product" icon-pack="feather" icon="icon-box">
                        <template>
                          <div id="data-list-list-view" class="data-list-container">
                            <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                              :data="sidebarData" />
                            <vs-table ref="table" :data="products">
                              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                                  <!-- ACTION - DROPDOWN -->
                                  <!-- ADD NEW -->
                                  <div
                                    class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                                    @click="addNewData">
                                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                                    <span class="ml-2 text-base text-primary">Add Product</span>
                                  </div>
                                </div>
                              </div>
                              <template slot="thead">
                                <vs-th>Name</vs-th>
                                <vs-th>Account</vs-th>
                                <vs-th sort-key="username">Quantity</vs-th>
                                <vs-th>UoM</vs-th>
                                <vs-th>Unit Excl. Tax</vs-th>
                                <vs-th>Total Excl. Tax</vs-th>
                                <vs-th>VAT</vs-th>
                                <vs-th>Total Incl. Tax</vs-th>
                                <vs-th>Action</vs-th>
                              </template>
                              <template slot-scope="{data}">
                                <tbody>
                                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td>{{ tr.product }}</vs-td>
                                    <vs-td v-if="tr.cont">{{ tr.cont }}</vs-td>
                                    <vs-td v-else>-</vs-td>
                                    <vs-td>{{ Math.abs(tr.quantity).toFixed(2) }}</vs-td>
                                    <vs-td>{{ tr.uom }}</vs-td>
                                    <vs-td>{{ Math.abs(tr.unit_price_htva).toFixed(2) }} {{ tr.currency }}</vs-td>
                                    <vs-td>{{ Math.abs(Math.abs(tr.quantity) * Math.abs(tr.unit_price_htva)).toFixed(2) }}
                                      {{ tr.currency }}</vs-td>
                                    <vs-td>{{ tr.tva_pct }}%</vs-td>
                                    <vs-td>{{ (Math.abs(tr.quantity * tr.unit_price_htva) * (1 + Math.abs(tr.tva_pct) /
                                      100)).toFixed(2) }} {{ tr.currency }}</vs-td>

                                    <vs-td class="whitespace-no-wrap">
                                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        @click.stop="editData(tr)" />
                                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                        class="ml-2" @click.stop="deleteProduct(tr.id, tr.product)" />
                                    </vs-td>
                                  </vs-tr>
                                </tbody>
                              </template>
                            </vs-table>
                          </div>
                        </template>
                        <vs-alert color="success" title="Total" active="true" class="mt-4" style="height:130px;">Total Excl. Tax : {{
                          thesum }} 
                          <vs-button type="border" size="small" color="danger" @click="updateVat(true)">The total Include VAT</vs-button>
                          <br />Tax : {{ thetax }}<br/>Total
                          Incl. Tax : {{ thesumtt }}&nbsp;
                          <!--<vs-button type="border" size="small" color="danger" class="mt-2" @click="updateVat(false)">Correct Missing VAT</vs-button>--></vs-alert>
                      </vs-tab>
                    </vs-tabs>
                  </vx-card>
                </div>
              </div>
            </div>
            <br />
            <br />
            <!-- Save & Reset Button -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                </div>
                <br />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moment from "moment";
import DataViewSidebar from "./DataViewSidebar.vue";

export default {
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker
  },
  data() {
    return {
      amountHtvaInitiallyIncludingVat:false,
      isfirstlaunch: false,
      ispaid: false,
      isvalid: false,

      scale: 1,
      minScale: 0.5,
      maxScale: 3,
      dragging: false,
      startX: 0,
      startY: 0,
      translateX: 0,
      translateY: 0,
thetax:0,
      thesum: 0,
      thesumtt: 0,
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      producttodelete: null,
      data_option_outlay_category: [],
      outlayId: null,
      isConnect: null,
      urlDocument: null,
      dropBoxImageLink: null,
      dateInitial: null,
      dateNew: null,
    };
  },
  computed: {

    imageStyles() {
      return {
        transform: `scale(${this.scale}) translate(${this.translateX / 1.5}px, ${this.translateY / 1.5}px)`,
        transition: 'transform 0s',
        cursor: this.dragging ? 'grabbing' : 'grab'
      };
    },
    products() {
      try {
        if (this.$store.state.operationList.expense.expenselines.length > 0 && !this.isfirstlaunch) {
          this.isfirstlaunch = true;
          this.calculateSumHT();
        }
        return this.$store.state.operationList.expense.expenselines;

      } catch (error) {
        return null
      }
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    }
  },
  watch: {
    products: {
      handler() {
        this.calculateSumHT();
      },
      deep: true,
    },
    'operation_data.date': function (newDate, oldDate) {
      this.dateNew = newDate;
      this.dateInitial = oldDate;
    }
  },

  methods: {
    maketheupdatevat() {
      let item = { idoperation: this.$route.params.userId, amountHtvaInitiallyIncludingVat: this.amountHtvaInitiallyIncludingVat }
      this.$store.dispatch('operationList/changeVat', item).catch(err => { console.error(err) })
    },
    updateVat(amountHtvaInitiallyIncludingVat) {
      this.amountHtvaInitiallyIncludingVat = amountHtvaInitiallyIncludingVat
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm VAT movement",
        text: `You are about to move the VAT`,
        accept: this.maketheupdatevat,
        acceptText: "Yes!"
      });
    },
    zoomIn() {
      if (this.scale < this.maxScale) {
        this.scale *= 1.05;
      }
    },
    zoomOut() {
      if (this.scale > this.minScale) {
        this.scale /= 1.05;
      }
    },
    onWheel(event) {
      event.preventDefault();

      const scaleAmount = 0.1; // Facteur de zoom
      const containerRect = this.$refs.container.getBoundingClientRect();

      // Position du curseur par rapport au conteneur
      const cursorX = event.clientX - containerRect.left;
      const cursorY = event.clientY - containerRect.top;

      // Position du curseur par rapport à l'image
      const imageX = cursorX - this.translateX;
      const imageY = cursorY - this.translateY;

      // Calcul du nouveau facteur de zoom
      const newScale = this.scale * (event.deltaY < 0 ? 1 + scaleAmount : 1 - scaleAmount);

      // Restreindre le zoom entre minScale et maxScale
      this.scale = Math.min(Math.max(newScale, this.minScale), this.maxScale);

      // Ajustement de la translation pour centrer le zoom sur la position du curseur
      if (this.scale !== this.minScale && this.scale !== this.maxScale) {
        this.translateX = imageX - imageX * newScale / this.scale + cursorX - imageX;
        this.translateY = imageY - imageY * newScale / this.scale + cursorY - imageY;
      }
    },
    startDrag(event) {
      event.preventDefault();
      this.dragging = true;
      this.startX = event.clientX - this.translateX;
      this.startY = event.clientY - this.translateY;
    },
    onDrag(event) {
      event.preventDefault();
      if (this.dragging) {
        this.translateX = event.clientX - this.startX;
        this.translateY = event.clientY - this.startY;
      }
    },
    endDrag() {
      event.preventDefault();
      this.dragging = false;
    },

    calculateSumHT() {
      try {
        let sum = 0;
        let sumtt = 0;
        this.products.forEach(e => {
          sum = sum + (Math.abs(e.unit_price_htva) * Math.abs(e.quantity))
          sumtt = sumtt + (Math.abs(e.quantity * e.unit_price_htva) * (1 + Math.abs(e.tva_pct) / 100))
        });
        this.thesum = sum.toFixed(2) + " " + this.products[0].currency
        this.thesumtt = sumtt.toFixed(2) + " " + this.products[0].currency
        this.thetax = (sumtt-sum).toFixed(2) + " "+ this.products[0].currency

      } catch (error) {
        this.thesum = 0
        this.thesumtt = 0
      }
    },
    record_data_go_to_add_person() {
      localStorage.setItem("creating-operation-and-need-to-add-user", true);
      localStorage.setItem(
        "creating-operation-and-need-to-add-user-page-source",
        "/outlay-edit/" + this.operation_data.id
      );
      this.$router.push("/person-add").catch(() => { });
    },

    async setDataFromNewPerson() {
      if (localStorage.getItem('creating-operation-and-need-to-add-user')) {
        this.dataOperationCategory = localStorage.getItem('creating-operation-and-need-to-add-user-category');
        this.dataDate = localStorage.getItem('creating-operation-and-need-to-add-user-date');
        setTimeout(() => {
          const storedValue = Number(localStorage.getItem('creating-operation-and-need-to-add-user-person'));
          console.log("Valeur stockée :", storedValue);
          console.log("Liste des personnes :", this.data_option_people_name);

          if (!storedValue) {
            console.warn("⚠️ Aucune valeur trouvée dans localStorage !");
          } else {
            console.log("🔍 Recherche de l'élément correspondant...");
            this.dataIdPeople = this.data_option_people_name.find((p) => p.value.valueOf() === storedValue);

            console.log("🔹 Résultat de find() :", this.dataIdPeople);

            if (!this.dataIdPeople) {
              console.warn(`⚠️ Aucun élément trouvé avec la valeur '${storedValue}' dans data_option_people_name`);
            } else {
              console.log("✅ Élément trouvé :", this.dataIdPeople);
            }
          }
        }, 1000);
      }

      localStorage.removeItem('creating-operation-and-need-to-add-user');
      localStorage.removeItem('creating-operation-and-need-to-add-user-category');
      localStorage.removeItem('creating-operation-and-need-to-add-user-date');
      localStorage.removeItem('creating-operation-and-need-to-add-user-page-source');
    },
   /* async getOutlayCategory() {
      axios.get("/outlaycategory/active-combobox/data").then(response => {
        this.data_option_outlay_category = [...response.data];

        const ItemIndex = this.data_option_outlay_category.findIndex(
          p => p.value === this.operation_data.outlaycategory.id
        );
        this.outlayId = this.data_option_outlay_category.splice(ItemIndex, 1);
      });
    },*/
    async getPeople() {
      axios.get("/people_name/data").then(response => {
        this.data_option_people_name = [...response.data];
        if (this.operation_data.people.length > 0) {
          const ItemIndex = this.data_option_people_name.findIndex(
            p => p.value === this.operation_data.people[0].id
          );
          this.personId = this.data_option_people_name.splice(ItemIndex, 1);
        }
        this.setDataFromNewPerson();
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable"
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable"
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/outlay/" + this.operation_data.id });
      this.showEnableSuccess();
    },
    // Les .catch vides (et les `reject(error)` sur un identifiant inexistant)
    // masquaient tout echec : l'ecran annoncait le succes quand meme.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled"
      });
    },
    deleteRecord() {
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/outlay/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted"
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData() {
      if (this.operation_data.id) {
        var idoperation = this.operation_data.id;
        var idcategoryoperation = this.operation_data.operationcategory.id;
        this.sidebarData = { idoperation, idcategoryoperation };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Alert!",
          text: "Please select a Person before!"
        });
      }
    },
    save_changes() {
      let obj = {};

      let idPerson = null;
      if (this.personId[0] != null) {
        idPerson = this.personId[0].value
      }
      else {
        idPerson = this.personId.value;
      }
      let dtNew = new Date(this.dateNew);
      let yearNew = dtNew.getFullYear();
      let monthNew = dtNew.getMonth() + 1;

      let currentPath = this.operation_data.name.split("/");
      currentPath[0] = yearNew;
      currentPath[1] = monthNew.toString().padStart(2, '0');

      let newPath = "/done/" + yearNew + "/" + monthNew.toString().padStart(2, '0') + "/" + currentPath[currentPath.length - 1]


      if (this.outlayId) {
        obj = {
          id: this.operation_data.id,
          idperson: idPerson,
          date: moment(this.operation_data.date),
          date_delivery_desired: moment(this.operation_data.date_delivery_desired),
          idoutlaycategory: this.outlayId.value,
          isexppaid: this.operation_data.isexppaid,
          isexpvalid: this.operation_data.isexpvalid,
          newname: newPath,
          oldname: this.operation_data.name,
          name: this.operation_data.name,
          idoperationcategory: '8',
        };
      } else {
        obj = {
          id: this.operation_data.id,
          idperson: idPerson,
          date: moment(this.operation_data.date),
          date_delivery_desired: moment(this.operation_data.date_delivery_desired),
          isexppaid: this.operation_data.isexppaid,
          isexpvalid: this.operation_data.isexpvalid,
          newname: newPath,
          oldname: this.operation_data.name,
          name: this.operation_data.name,
          idoperationcategory: '8',
        };
      }

      console.log(obj)

      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch(err => {
            console.log(err);
          });
        this.$router.push({ path: "/outlay/outlay-list" });

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The operation was successfully updated"
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted"
      });
    },
    deleteProductOne() {
      const obj = {
        id: this.producttodelete
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItemExpense", obj).catch(err => {
        console.error(err);
      });
      this.showDeleteAddressSuccess();
      this.calculateSumHT();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product"
      });
    },
    editData(data) {
      data.idperson = this.operation_data.id;
      data.idcategoryoperation = this.operation_data.operationcategory.id;
      this.sidebarData = data;

      this.toggleDataSidebar(true);

    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchExpense", userId)
          .then(res => {
            this.operation_data = res.data;
            try {

              if (this.operation_data.isexpvalid && this.operation_data.isexppaid) {

                this.$vs.notify({
                  color: "warning",
                  title: "Expense is Locked",
                  text: "The expense has already been confirmed and paid."
                });
                this.$router.push({ path: "/outlay/" + this.operation_data.id });
              }
            } catch (error) {

            }
            this.getPeople();
            //this.getOutlayCategory();
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    
    try {
      
    this.fetch_operation_data(this.$route.params.userId).then((e) => {

});
    } catch (error) {
      
    }

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>


<style lang="scss">
.zoom-container {
  overflow: hidden;
  position: relative;
}

.zoom-container img {
  user-select: none;
  /* Empêche la sélection de l'image lors du drag */
}

.controls {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.controls button {
  font-size: 20px;
  margin: 5px;
}
</style>

